import { Box, Typography, useTheme } from '@mui/material';
import { LocaleContext } from '@/Contexts/LocaleContext';
import { useContext } from 'react';

interface TabPanelProps {
  headerText?: string;
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const theme = useTheme();
  const { children, value, index, headerText, ...other } = props;
  const { translatedText } = useContext(LocaleContext);

  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      sx={{
        width: '100vw',
      }}
      {...other}
    >
      <Typography variant='subtitle2' color={theme.palette.taigaTint1.main} gutterBottom>
        {translatedText.myaccount.myAccount}
      </Typography>

      {headerText && (
        <Typography variant='h2' mb={'32px'}>
          {headerText}
        </Typography>
      )}
      {value === index && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            gap: 2,
            backgroundColor: theme.palette.sandShade1.main,
            borderRadius: 2,
            padding: 3,
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: theme.palette.sandShade1.main,
              borderRadius: '4px',
            },
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
}

export default TabPanel;
